function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//
//
//
//
//
import * as VueGoogleMaps from "gmap-vue";
export default {
  mixins: [VueGoogleMaps.MapElementMixin],
  props: {
    marker: {
      type: Object,
      "default": undefined
    },
    offsetX: {
      type: Number,
      "default": 0
    },
    offsetY: {
      type: Number,
      "default": 0
    },
    alignment: {
      type: String,
      "default": "top"
    },
    zIndex: {
      type: Number,
      "default": 50
    },
    cssPosition: {
      type: Boolean,
      "default": false
    },
    nuxtMode: {
      type: Boolean,
      "default": false
    }
  },
  inject: {
    $clusterPromise: {
      "default": null
    }
  },
  beforeCreate: function beforeCreate(options) {
    if (this.$clusterPromise) {
      options.map = null;
    }

    return this.$clusterPromise;
  },
  methods: {
    afterCreate: function afterCreate(inst) {
      var _this = this;

      if (this.$clusterPromise && !this.isMarkerAdded) {
        this.$clusterPromise.then(function (co) {
          co.addMarker(inst);
          _this.$clusterObject = co;
          _this.isMarkerAdded = true;
        });
      }
    }
  },
  data: function data() {
    return {
      opacity: 0.01
    };
  },
  watch: {
    marker: function marker(val) {
      var _this2 = this;

      this.$mapPromise.then(function (map) {
        return _this2.$overlay.setPosition();
      });
    },
    zIndex: function zIndex(val) {
      if (this.$overlay) {
        this.$overlay.repaint();
      }
    }
  },
  provide: function provide() {
    var _this3 = this;

    var self = this;
    return this.$mapPromise.then(function (map) {
      var Overlay = /*#__PURE__*/function (_google$maps$OverlayV) {
        _inherits(Overlay, _google$maps$OverlayV);

        var _super = _createSuper(Overlay);

        function Overlay(map) {
          var _this4;

          _classCallCheck(this, Overlay);

          _this4 = _super.call(this);

          _this4.setMap(map);

          _this4.draw = function () {
            return _this4.repaint();
          };

          _this4.setPosition = function () {
            return _this4.repaint();
          };

          return _this4;
        }

        _createClass(Overlay, [{
          key: "repaint",
          value: function repaint() {
            var div = self.$el;

            if (self.nuxtMode && !div.offsetWidth && !div.offsetHeight) {
              return;
            }

            var projection = this.getProjection();

            if (projection && div) {
              var posPixel = projection.fromLatLngToDivPixel(self.latLng);
              var x, y;

              switch (self.alignment) {
                case "top":
                  x = posPixel.x - div.offsetWidth / 2;
                  y = posPixel.y - div.offsetHeight;
                  break;

                case "bottom":
                  x = posPixel.x - div.offsetWidth / 2;
                  y = posPixel.y;
                  break;

                case "left":
                  x = posPixel.x - div.offsetWidth;
                  y = posPixel.y - div.offsetHeight / 2;
                  break;

                case "right":
                  x = posPixel.x;
                  y = posPixel.y - div.offsetHeight / 2;
                  break;

                case "center":
                  x = posPixel.x - div.offsetWidth / 2;
                  y = posPixel.y - div.offsetHeight / 2;
                  break;

                case "topleft":
                case "lefttop":
                  x = posPixel.x - div.offsetWidth;
                  y = posPixel.y - div.offsetHeight;
                  break;

                case "topright":
                case "righttop":
                  x = posPixel.x;
                  y = posPixel.y - div.offsetHeight;
                  break;

                case "bottomleft":
                case "leftop":
                  x = posPixel.x - div.offsetWidth;
                  y = posPixel.y;
                  break;

                case "bottomright":
                case "rightbottom":
                  x = posPixel.x;
                  y = posPixel.y;
                  break;

                default:
                  throw new Error("Invalid alignment type of custom marker!");
                  break;
              }

              if (self.cssPosition) {
                div.style.transform = "translate(".concat(x + self.offsetX, "px, ").concat(y + self.offsetY, "px)");
              } else {
                div.style.left = x + self.offsetX + "px";
                div.style.top = y + self.offsetY + "px";
              }

              div.style["z-index"] = self.zIndex;
            }
          }
        }, {
          key: "onAdd",
          value: function onAdd() {
            var div = self.$el;
            var panes = this.getPanes();
            div.style.position = "absolute";
            div.style.display = "inline-block";
            div.style.zIndex = self.zIndex;
            panes.overlayLayer.appendChild(div);
            panes.overlayMouseTarget.appendChild(div);

            this.getDraggable = function () {
              return false;
            };

            this.getPosition = function () {
              return new google.maps.LatLng(self.lat, self.lng);
            };

            self.afterCreate(this);
          }
        }, {
          key: "onRemove",
          value: function onRemove() {
            if (self.$el) {
              var ua = window.navigator.userAgent;
              var msie = ua.indexOf("MSIE ");

              if (msie > 0 || !!ua.match(/Trident.*rv\:11\./)) {
                self.$el.parentNode.removeChild(self.$el);
              } else {
                self.$el.remove();
              }
            }
          }
        }]);

        return Overlay;
      }(google.maps.OverlayView);

      _this3.$overlay = new Overlay(map);
      setTimeout(function () {
        if (_this3.$overlay) {
          _this3.$overlay.repaint();

          _this3.opacity = 1;
        }
      }, 100);
    });
  },
  computed: {
    lat: function lat() {
      return parseFloat(isNaN(this.marker.lat) ? this.marker.latitude : this.marker.lat);
    },
    lng: function lng() {
      return parseFloat(isNaN(this.marker.lng) ? this.marker.longitude : this.marker.lng);
    },
    latLng: function latLng() {
      if (this.marker instanceof google.maps.LatLng) {
        return this.marker;
      }

      return new google.maps.LatLng(this.lat, this.lng);
    }
  },
  destroyed: function destroyed() {
    if (this.$clusterObject) {
      this.$clusterObject.removeMarker(this.$overlay, true);
    } else {
      if (this.$overlay) {
        this.$overlay.setMap(null);
        this.$overlay = undefined;
      }
    }
  }
};